var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex align-items-center flex-column mt-4" },
    [
      _vm.wizardstep !== undefined
        ? _c(
            "div",
            { staticClass: "col d-flex flex-column align-items-center mb-2" },
            [
              _vm.wizardTitle
                ? _c("h2", { staticClass: "text-brand-dark mt-2 fw-fat" }, [
                    _vm._v(_vm._s(_vm.wizardTitle)),
                  ])
                : _vm._e(),
              _c("h5", { staticClass: "mt-2 fw-fat mb-2" }, [
                _vm._v(_vm._s(_vm.wizardstep.headline)),
              ]),
              _c("p", {
                staticClass: "description-box my-2 text-headline-color",
                domProps: {
                  innerHTML: _vm._s(_vm.modifyString(_vm.description)),
                },
              }),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col content mt-2 text-center" },
        [
          _vm.wizardstep.type !== "wizardStep"
            ? _c(_vm.wizardstep.type, {
                tag: "Component",
                attrs: { wizardstep: _vm.wizardstep, settings: _vm.settings },
                on: {
                  buttonClicked: function ($event) {
                    return _vm.setStorage()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }